import { all } from 'redux-saga/effects';

import highlights from './highlights/saga';
import projects from './projects/saga';
import contact from './contact/saga';

export default function* rootSaga() {
  return yield all([highlights, projects, contact]);
}
